export default "__VITE_ASSET__PsPde5u$__"